export default __webpack_public_path__ + "static/media/10.20b0116f.PNG";